import React, { useEffect, useState } from "react";
import Sidebar from "../../partials/aside/Sidebar";
import httpService from "../../../services/httpServices/httpServices";
import helperNumber from "../../../helpers/numbers";
import { Redirect, Link } from "react-router-dom";
import helperSpinner from "../../../helpers/spinner";
import TitleBar from "../../partials/content/TitleBar";
import Pagination from "../../partials/content/Pagination";

function AllTickets() {
  const [tickets, setTickets] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [countItemPerPage, setCountItemPerPage] = useState(10);
  const [countPage, setCountPage] = useState(1);
  const [ticketIDSearchFilter, setTicketIDSearchFilter] = useState();

  useEffect(() => {
    getTickets();
  }, []);

  useEffect(() => {
    getTickets();
  }, [currentPage, countItemPerPage, ticketIDSearchFilter]);

  const getTickets = async () => {
    const searchFilterQuery = getSearchFilterQuery();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let resultSendRequestGetAllRequest = await sendRequestGetAllRequest(
      searchFilterQuery
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!tickets) {
      return;
    }
    setTickets(resultSendRequestGetAllRequest.tickets);
    setCountPage(resultSendRequestGetAllRequest.count_page);
  };

  const paginationItemOnClickHandler = async (e) => {
    if (!e.target.attributes[1]) {
      return;
    }

    setCurrentPage(e.target.attributes[1].value);
  };

  const generatePagination = () => {
    return (
      <div className="py-2 d-flex flex-column flex-md-row  align-items-md-center  ">
        <Pagination
          countPage={countPage}
          currentPage={currentPage}
          paginationItemOnClickHandler={paginationItemOnClickHandler}
        />
      </div>
    );
  };

  const getSearchFilterQuery = () => {
    let searchFilterQuery = "";
    if (ticketIDSearchFilter) {
      searchFilterQuery = `${searchFilterQuery}&id=${ticketIDSearchFilter}`;
    }

    return searchFilterQuery;
  };

  const sendRequestGetAllRequest = async (searchFilterQuery) => {
    let tickets;
    const headersRequest = getHeaderForRequest();
    try {
      tickets = await httpService.getRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/ticket/all-ticket?page=${currentPage}&number=${countItemPerPage}${searchFilterQuery}`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return;
    }
    return tickets.data.data;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const setBadgeForStatus = (statusTitle) => {
    let tagBadge;
    switch (statusTitle) {
      case "در حال انتظار":
        tagBadge = <span className="badge  badge-warning">{statusTitle}</span>;
        break;
      case "پاسخ داده شده":
        tagBadge = <span className="badge  badge-info">{statusTitle}</span>;
        break;
      case "بسته شده":
        tagBadge = <span className="badge  badge-success">{statusTitle}</span>;
        break;
    }

    return tagBadge;
  };

  const generateTickets = () => {
    return (
      <>
        <div className="alert alert-info">
          <div className="row pb-2">
            <div className="d-flex align-items-center">
              <div className="pl-2">
                <label>جستجو در شماره تیکت</label>
              </div>
              <div>
                <input
                  onKeyUp={(e) => setTicketIDSearchFilter(e.target.value)}
                  onWheel={(event) => event.currentTarget.blur()}
                  className="form-control"
                  type="number"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="table-responsive">
          <table className="table table-hilite tbl-td-white-space table-hover m-0">
            <thead>
              <tr>
                <td>#</td>
                <td>شماره تیکت</td>
                <td>نام کاربر</td>
                <td>عنوان تیکت</td>
                <td>وضعیت</td>
                <td>تاریخ درج</td>
                <td>مشاهده</td>
              </tr>
            </thead>
            <tbody>
              {tickets.map((ticket, index) => {
                return (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{ticket.id}</td>
                    <td>{ticket.user_name}</td>
                    <td>{ticket.title}</td>
                    <td>{setBadgeForStatus(ticket.status)}</td>
                    <td>{helperNumber.toPersianNum(ticket.createAt)}</td>
                    <td>
                      <div>
                        <span className="pl-2">
                          <Link
                            to={`/ticket/answer/${ticket.id}`}
                            className="btn btn-success  "
                          >
                            <i className="fa fa-eye"></i>
                          </Link>
                        </span>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {countPage > 1 ? generatePagination() : <></>}
      </>
    );
  };

  return (
    <>
      <Sidebar openItem="manage-tickets" activeItem="all-tickets" />

      <div className="content-wrapper">
        <TitleBar title="تیکت های کاربران" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div className="alert alert-info">
                <span className="pl-2">
                  <i className="fa fa-warning"></i>
                </span>
                <span>حتما تمامی تیکت ها باید در حالت 'بسته شده' باشند</span>
              </div>
              {tickets.length == 0 && ticketIDSearchFilter == null ? (
                <></>
              ) : (
                generateTickets()
              )}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default AllTickets;
